<template>
  <FourElement></FourElement>
  <div class="collection-container">
    <List></List>
    <AddModal></AddModal>
  </div>
</template>

<script>
import FourElement from './components/FourElement.vue'
import List from './components/List.vue'
import AddModal from './components/AddModal.vue'
import { toRefs, reactive, provide, onMounted } from 'vue'
// import dayjs from 'dayjs'
import { message } from 'ant-design-vue'
import {
  queryAllLiveRooms,
  queryPageAnchorRecommend,
  addAnchorRecommend,
  updateAnchorRecommend,
  deleteAnchorRecommend,
  recommend
} from 'server/modules/live'
export default {
  components: {
    FourElement,
    List,
    AddModal
  },
  setup() {
    const state = reactive({
      searchParams: {},
      isEdit: false,
      pagination: {
        current: 1, //默认的当前页数
        pageSize: 10, //每页显示几条数据
        total: 0,
        onChange: (current, pageSize) => {
          state.pagination.current = current
          state.pagination.pageSize = pageSize
          state.getTabList()
        }
      },
      //表格数据
      dataSource: [],
      //直播间数据
      liveRoomSelect: [],
      //列
      columns: [
        {
          title: '序号',
          align: 'center',
          dataIndex: 'id',
          key: 'id'
        },
        {
          title: '直播间',
          align: 'center',
          dataIndex: 'liveName',
          key: 'liveName'
        },
        {
          title: '推荐主图',
          dataIndex: 'imgUrl',
          key: 'imgUrl',
          align: 'center'
        },
        // {
        //   title: '跳转链接',
        //   align: 'center',
        //   dataIndex: 'jumpLink',
        //   key: 'jumpLink'
        // },
        {
          title: '状态',
          dataIndex: 'recommend',
          key: 'recommend',
          align: 'center'
        },
        {
          title: '操作',
          dataIndex: 'operate',
          align: 'center'
        }
      ],
      initList: () => {
        state.getTabList()
      },
      //table数据
      getTabList: () => {
        const param = {
          pageNum: state.pagination.current,
          pageSize: state.pagination.pageSize
        }
        queryPageAnchorRecommend(param)
          .then(e => {
            if (e.success) {
              state.dataSource = e.data.data.list.records
              state.pagination.total = e.data.data.total
            }
          })
          .catch(err => {
            console.log('err: ', err)
          })
      },
      getLiveRoomList() {
        queryAllLiveRooms()
          .then(e => {
            if (e.success) {
              state.liveRoomSelect = e.data.data
            }
          })
          .catch(err => {
            console.log('err: ', err)
          })
      },

      modalVisible: false,
      formRef: null,
      form: {},
      //校验
      rules: {
        imgUrl: [{ required: true, message: '请上传图片！' }]
        // jumpLink: [{ required: true, message: '请输入跳转链接！' }]
      },
      add: () => {
        state.isEdit = false
        state.modalVisible = true
      },
      //添加图片
      imageType: {
        tip: '只能上传.jpg文件，尺寸 64*96',
        size: 2048,
        width: 64,
        height: 96
      },
      //获取图片地址
      setImgUrl: url => {
        state.form.imgUrl = url
        state.formRef.clearValidate(['imgUrl'])
      },
      //删除图片
      delActivityImg: () => {
        state.form.imgUrl = ''
      },
      modalCancel: () => {
        state.formRef.clearValidate()
        state.form = {}
        state.modalVisible = false
      },
      modalSubmit: async () => {
        state.formRef
          .validateFields()
          .then(() => {
            const param = {
              ...state.form
            }
            if (param.id) {
              updateAnchorRecommend(param)
                .then(e => {
                  if (e.success) {
                    message.success('更新成功')
                    state.formRef.clearValidate()
                    state.form = {}
                    state.modalVisible = false
                    state.initList()
                  } else {
                    message.warning(e.data)
                  }
                })
                .catch(err => {
                  console.log('err: ', err)
                  message.warning(err.retInfo)
                })
            } else {
              addAnchorRecommend(param)
                .then(e => {
                  if (e.success) {
                    if (e.data.succes) {
                      message.success('添加成功')
                      state.formRef.clearValidate()
                      state.form = {}
                      state.modalVisible = false
                      state.initList()
                    } else {
                      message.warning(e.data.data)
                    }
                  } else {
                    message.warning(e.retInfo)
                  }
                })
                .catch(err => {
                  console.log('err: ', err)
                  message.warning(err.retInfo)
                })
            }
          })
          .catch(e => {
            console.log('e: ', e)
          })
      },
      handleEdit: info => {
        if (info) {
          state.isEdit = true
          state.form = {
            ...info
          }
          state.modalVisible = true
        }
      },
      handleDel: info => {
        if (info) {
          deleteAnchorRecommend(info)
            .then(e => {
              if (e.success) {
                message.success('删除成功')
                state.initList()
              } else {
                message.warning(e.data)
              }
            })
            .catch(err => {
              console.log('err: ', err)
              message.warning(err.retInfo)
            })
        }
      },
      handleRecommend: info => {
        if (info) {
          const param = {
            id: info.id
          }
          recommend(param)
            .then(e => {
              if (e.success) {
                if (e.data.succes) {
                  if (e.data.data.recommend === 0) {
                    message.success('取消推荐成功')
                  } else {
                    message.success('推荐成功')
                  }
                  state.modalVisible = false
                  state.initList()
                } else {
                  message.warning(e.data.data)
                }
              } else {
                message.warning(e.retInfo)
              }
            })
            .catch(err => {
              console.log('err: ', err)
              message.warning(err.retInfo)
            })
        }
      }
      // ,
      // handleEnd: info => {
      //   if (info) {
      //     const param = {
      //       id: info.id,
      //       recommend: 0
      //     }
      //     updateAnchorRecommend(param)
      //       .then(e => {
      //         if (e.success) {
      //           message.success('推荐成功')
      //           state.modalVisible = false
      //           state.initList()
      //         } else {
      //           message.warning(e.data)
      //         }
      //       })
      //       .catch(err => {
      //         console.log('err: ', err)
      //         message.warning(err.retInfo)
      //       })
      //   }
      // }
    })
    onMounted(() => {
      state.initList()
      state.getLiveRoomList()
    })
    provide('initState', state)
    return {
      ...toRefs(state)
    }
  }
}
</script>

<style lang="scss" scoped>
.collection-container {
  margin: 20px;
  padding: 20px;
  overflow: hidden;
  background: #ffffff;
}
</style>
